import Aura from '@primeng/themes/aura';

export const environment = {
  apiUrl: 'https://api.hubike.dev.itcentar.rs/api/admin',
  loadingToastDelay: 500,
  dateFormat: 'dd.MM.yyyy HH:mm',
  theme: {
    color: 'zinc',
    preset: Aura,
  },
  googleMapsApiKey: 'AIzaSyAnX4GflwQKEYeNwqHZJVigqaN_d05dpco',
};
